const reasons = [
  'longLeave',
  'roleChange',
  'wantsManualRenew',
  'notATeacherAnymore',
  'tooExpensive',
  'doesntUnderstand',
  'missingFeatures',
  'missingContent',
  'vacation',
  'schoolWillProvideLicense',
  'otherTool2',
  'other',
] as const;

export type ReasonType = (typeof reasons)[number];

export interface ReasonToCancelType {
  value: ReasonType;
  hasDetails?: boolean;
}

export const reasonsToCancel: ReasonToCancelType[] = [
  { value: 'longLeave' },
  { value: 'roleChange' },
  { value: 'wantsManualRenew' },
  { value: 'notATeacherAnymore' },
  { value: 'tooExpensive' },
  { value: 'doesntUnderstand' },
  { value: 'missingFeatures', hasDetails: true },
  { value: 'missingContent', hasDetails: true },
  { value: 'vacation' },
  { value: 'schoolWillProvideLicense' },
  { value: 'otherTool2', hasDetails: true },
  { value: 'other', hasDetails: true },
];
